<template>
  <div>
    <div class="search-area" v-if="isShowDate">
      <div class="block" v-if="isSingleDate">
        <el-date-picker
          v-model="date"
          :type="singleDate.type"
          :placeholder="singleDate.placeholder">
        </el-date-picker>
        <el-button @click="searchDate">搜索</el-button>
      </div>
      <div class="block" v-else>
        <el-date-picker
          v-model="from"
          :type="doubleDate.type"
          :format="doubleDate.format"
          :placeholder="doubleDate.placeholder">
        </el-date-picker>
        <el-date-picker
          v-model="to"
          :type="doubleDate.type"
          :format="doubleDate.format"
          :placeholder="doubleDate.placeholder2">
        </el-date-picker>
        <el-button>搜索</el-button>
      </div>
    </div>
    <div class="chartGroup" v-for="item in display.group">
        <div v-for="chart in item.charts"
        :class="{ 
          'layout10': item.layout==10,
          'layout20': item.layout==20,
          'layout30': item.layout==30,
        }">
          <dimensional-bar :bar='bar' v-if="chart.type == 'bar'"></dimensional-bar>
          <dimensional-pie :pie='pie' v-if="chart.type == 'pie'"></dimensional-pie>
          <dimensional-table :table='table' :display="display" v-if="chart.type == 'table'"></dimensional-table>
        </div>
    </div>
    <!-- <dimensional-pie 
      :title='pie.title'
      :tooltip='pie.tooltip'
      :legend='pie.legend'
      :series='pie.series'>
    </dimensional-pie> -->
    <!-- <dimensional-bar 
      :title='bar.title'
      :tooltip='bar.tooltip'
      :legend='bar.legend'
      :series='bar.series'
      :direction='bar.direction'
      :color='bar.color'
      :directionData='bar.directionData'
      :isShowAsix='bar.isShowAsix'
      :isShowSplitLine='bar.isShowSplitLine'>
    </dimensional-bar> -->
  </div>
</template>
<script>
  import http from '../../../assets/js/http'
  import dimensionalBar from './chart/dimensionalBar'
  import dimensionalPie from './chart/dimensionalPie'
  import dimensionalTable from './chart/dimensionalTable'
  export default {
    name: 'formRender',
    props: {
      contentId: {
        type: Number,
        default() {
          return 0
        }
      },
      dealId: {
        type: Number,
        default() {
          return 0
        }
      }
    },
    data() {
      return {
        bar: {},
        pie: {},
        table: [],
        display: {},
        dateList: [
          {
            tag: 20,
            type: 'year',
            format: 'yyyy',
            placeholder: '选择年'
          },
          {
            tag: 30,
            type: 'month',
            format: 'yyyy-MM',
            placeholder: '选择月'
          },
          {
            tag: 40,
            type: 'date',
            format: 'yyyy-MM-DD',
            placeholder: '选择日'
          },
          {
            tag: 50,
            type: 'year',
            format: 'yyyy',
            placeholder: '开始年份',
            placeholder2: '结束年份'
          },
          {
            tag: 60,
            type: 'month',
            format: 'yyyy-MM',
            placeholder: '开始月份',
            placeholder2: '结束月份'
          },
          {
            tag: 70,
            type: 'date',
            format: 'yyyy-MM-DD',
            placeholder: '选择日期',
            placeholder2: '结束日期'
          }
        ],
        singleDate: {},
        doubleDate: {},
        date: '', // 日期
        from: '', // 开始日期
        to: '', // 结束日期
        isShowDate: true,
        isSingleDate: true
      }
    },
    created() {
      this.getData()
    },
    methods: {
      getData () {
        let url = `cms/contents/simple_chart/${this.dealId}`
        this.apiGet(url).then((res) => {
          if (res.code == 200) {
            this.initData(res)
          }
        })
      },
      searchDate() {
        let url = ''
        if (this.date != '') {
          let d = new Date(this.date).getTime() / 1000
          url = `cms/contents/simple_chart/${this.dealId}/?from=&to=&date=${d}`
        } else {
          let f = ''
          let t = ''
          if (this.from != '') {
            f = new Date(this.from).getTime() / 1000
          }
          if (this.to != '') {
            t = new Date(this.to).getTime() / 1000
          }
          url = `cms/contents/simple_chart/${this.dealId}/?from=${f}&to=${t}&date=`
        }
        this.apiGet(url).then((res) => {
          if (res.code == 200) {
            this.initData(res)
          }
        })
      },
      initData(res) {
        this.bar = res.data.chartData.bar
        this.pie = res.data.chartData.pie
        this.table = res.data.chartData.table
        this.display = res.data.dealConfig.display
        if (res.data.dealConfig.search.type == 10) {
          this.isShowDate = false
        } else if (res.data.dealConfig.search.type < 50 && res.data.dealConfig.search.type > 0) {
          this.isShowDate = true
          this.isSingleDate = true
          _(this.dateList).forEach((date) => {
            if (date.tag == res.data.dealConfig.search.type) {
              this.singleDate = date
            }
          })
        } else if (res.data.dealConfig.search.type >= 50 && res.data.dealConfig.search.type < 80) {
          this.isShowDate = true
          this.isSingleDate = false
          _(this.dateList).forEach((date) => {
            if (date.tag == res.data.dealConfig.search.type) {
              this.doubleDate = date
            }
          })
        }
      }
    },
    components: {
      dimensionalBar,
      dimensionalPie,
      dimensionalTable
    },
    mixins: [http]
  }
</script>
<style scoped>
.search-area{
  width: 100%;
}
.layout10{
  width: 100%;
}
.layout20{
  margin-right:3%;
  width: 47%;
  float: left;
}
.layout30{
  margin-right:2%;
  width: 30%;
  float: left;
}
</style>


// WEBPACK FOOTER //
// chartRender.vue?3c5c5ac6